<template>
  <div style="background-color: #fff;">
    <HeaderM :isMain="false"/>
    <Header/>
    
    <Nav :list="headerList"/>
    <SingleBanner/>
    <!-- <Bannner url="hezuo-bg.png" :title="title" :content="content" /> -->
    <div class="current-page-content" style="padding: 0px 0 17px 0;">
      <div class="title-blo">
        <div class="title">成为认可雇主单位价值</div>
      </div>
      <p class="jiazhi">
        1)培训员工，提升专业能力，增强工作效率和竞争力；<br />
        2)精准招聘，筛选具备相关技能和资格的候选人；<br />
        3)提升企业形象，吸引更多客户和人才；<br />
        4)增强员工归属感和忠诚度，提高工作积极性和满意度；<br />
        5)注重技术研发和创新，保持市场领先地位；<br />
        6)建立企业信誉，赢得客户信任，拓展合作机会。
      </p>

      <div class="title-blo">
        <div class="title">申请流程</div>
      </div>
      <div class="liucheng-list">
        <div
          v-for="(item, index) in liuchengList"
          :key="index"
          class="liucheng-item"
        >
          <div class="pic">
            <img :src="formatterImg(index)" />
          </div>
          <div class="liucheng-title">{{ item }}</div>
        </div>
      </div>

      <div class="title-blo">
        <div class="title">部分认可雇主列表</div>
      </div>
      <div class="renke-list">
        <div
          v-for="(item, index) in renkeList"
          :key="item.id"
          :class="index % 3 === 2 ? 'eliu-item' : ''"
          class="renke-item"
        >
          {{ item.name }}
        </div>
      </div>
      <el-pagination
        v-if="Number(total) !== 0"
        :current-page="page"
        :page-sizes="[10, 20, 30, 50, 100]"
        :page-size="limit"
        :total="Number(total)"
        layout="total, sizes, prev, pager, next, jumper"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
      />
    </div>
    <Footer/>
  </div>
</template>
<script>
import { mapState } from "vuex";
// import Bannner from "./components/banner.vue";

export default {
  computed: mapState([]),
  components: {
    //Bannner,
  },
  data() {
    return {
      title: "认可雇主单位",
      content:
        "企业合规官（CCO）培训考试服务平台特别为取证客户企业打造了一个企业形象展示平台——认可雇主单位。对于有用人需求的认可雇主单位，只需向平台提出申请，平台将根据企业合规管理高端人才库进行匹配，为雇主提供合适的优秀人才。这种双向选择的模式不仅提高了工作效率，也确保了人才与岗位的精准匹配。",
      liuchengList: [
        "提交申请表格",
        "平台审核",
        "签订协议",
        "授牌",
        "提供服务",
      ],
      renkeList: [],
      page: 1,
      limit: 30,
      total: 0,
      headerList:[
                {name:'首页', href:'/'},
                {name:'IFM雇主', href:'/'},
            ]
    };
  },
  created() {
    this.getDataFunc();
  },
  methods: {
    formatterImg(index) {
      return require(`@/assets/hms/renke-${index + 1}.png`);
    },
    handleSizeChange(size) {
      this.limit = size;
      this.page = 1;
      this.getDataFunc();
    },
    handleCurrentChange(page) {
      this.page = page;
      this.getDataFunc();
    },
    async getDataFunc() {
      const res = await this.$http.get("/api/news/cooperatorPage", {
        type: 2,
        limit: this.limit,
        page: this.page,
      });
      this.renkeList = res.data;
      this.total = res.total;
      console.log(res.data, "res");
    },
  },
};
</script>
<style lang="scss" scoped>
.current-page-content {
  width: 1120px;
  box-sizing: border-box;
  margin: 0 auto;
  background-color: #fff;
}
.title-blo {
  width: 616px;
  position: relative;
  height: 90px;
  line-height: 90px;
  color: #3d3d3d;
  text-align: left;
  font-size: 28px;
  font-weight: 700;
  font-family: "Microsoft YaHei";
  border-bottom: 1px solid #b5b5b5;
  .title {
    position: relative;
  }
  .title::after {
    content: "";
    position: absolute;
    width: 118px;
    height: 8px;
    background-color: #234688;
    left: 0px;
    bottom: -5px;
  }
}
.jiazhi {
  line-height: 30px;
  width: 616px;
  padding: 20px 0 30px 0;
  color: #3d3d3d;
  font-size: 16px;
  font-weight: 400;
  font-family: "Microsoft YaHei";
}

.liucheng-list {
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-top: 40px;
  .liucheng-item {
    width: 110px;
    height: 150px;
    color: #3d3d3d;
    text-align: center;
    font-size: 16px;
    font-weight: 700;
    font-family: "Microsoft YaHei";
    .pic {
      width: 110px;
      height: 110px;
      border-radius: 50%;
      // background-color: #234688;
      img {
        width: 100%;
      }
    }
    .liucheng-title {
      padding-top: 10px;
    }
  }
}

.renke-list {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  width: 100%;
  padding: 33px 0;
  .eliu-item {
    margin-right: 0px !important;
  }
  .renke-item {
    margin-bottom: 30px;
    width: 350px;
    margin-right: 70px;
    color: #3d3d3d;
    text-align: left;
    font-size: 16px;
    font-weight: 400;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    word-break: break-all;
  }
}
</style>
